import { IUser } from '../../../../state/user/user.interface';
import { IBoard } from '../../../settings/boards/boards.interface';
import { IItemBase, IWorkflowStepBase } from '../../items.interface';
import { IChanges } from '../items-history/items-history.interface';

export enum EGuideHistoryType {
  opened = 'opened',
  started = 'started',
  form = 'form',
  played = 'played',
  paused = 'paused',
  ended = 'ended',
  date = 'date',
}

export interface IWorkInstructionHistoryBase {
  id: number;
  guideSubmissionId: number;
  boardId: number;
  itemId: number;
  guideId: number;
  stepId: number;
  before: IBeforeAfter;
  after: IBeforeAfter;
  type: EGuideHistoryType;
  createdAt: string;
  createdBy: number | null;
  changedAt: string | null;
  changedBy: number | null;
  deletedAt: string | null;
  deletedBy: number | null;
}

export interface IWorkInstructionHistoryRelations {
  item?: IItemBase;
  board?: IBoard;
  createdByUser?: IUser;
  guideStep?: IWorkflowStepBase;
}

export interface IWorkInstructionHistoryTableColumns {
  id: number;
  workInstructionStep: string | undefined;
  user: string | undefined;
  changedValues: IChanges[];
  actionTakenAt: string;
}

export interface IWorkInstructionHistory extends IWorkInstructionHistoryBase, IWorkInstructionHistoryRelations {}

export interface IWorkInstructionFormValue {
  name: string;
  type: EGuideHistoryType.form;
  value: IBeforeAfter;
}

export interface IWorkInstructionPrimitiveValue {
  name: string;
  type: Exclude<EGuideHistoryType, EGuideHistoryType.form>;
  value: string;
}

export type TWorkInstructionValue = IWorkInstructionFormValue | IWorkInstructionPrimitiveValue;

export interface IBeforeAfter {
  [key: string]: TWorkInstructionValue;
}
